module.exports = __webpack_public_path__ + "static/media/0323_IMG_FE_LE_SOL_CARRELAGE_EXISTANT.054ab846.png";